var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-wrap',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"preview-data":_vm.previewData}},[_c('div',{staticClass:"pdf-wrap",attrs:{"id":"pdf-wrap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }